export const CDP_PRODUCTS = {
  DATA_LIFECYCLE: {
    id: 24,
    title: 'Data Lifecycle',
    route: 'data-lifecycle',
  },
};
